import { FormControlRoot } from "./FormControlRoot/FormControlRoot";
import { FormControlLabel } from "./FormControlLabel/FormControlLabel";
import { FormControlTooltip } from "./FormControlTooltip/FormControlTooltip";

export const Root = FormControlRoot;
export const Label = FormControlLabel;
export const Tooltip = FormControlTooltip;
